import { render, staticRenderFns } from "./AdminPanel.vue?vue&type=template&id=47c79ada"
import script from "./AdminPanel.vue?vue&type=script&lang=js"
export * from "./AdminPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports